"use client";

import StudentsCarousel from "@/components/studentsCarousel/StudentsCarousel";
import { StudentsTestimonialsGridCarousel } from "@/components/sections/StudentsCarousel";
import useWindowSize from "@/helpers/useWindowSize";

export default function StudentSeizedOppertunity({
  testimonials,
}: {
  StudentTestimonials?: any;
  isDesktop?: boolean;
  testimonials: any;
}) {
  const { isDesktop } = useWindowSize();
  if (isDesktop) {
    return (
      <div>
        <StudentsTestimonialsGridCarousel studentsDetails={testimonials} />
      </div>
    );
  }
  return (
    <div className={"px-3"}>
      <StudentsCarousel studensDetails={testimonials} />
    </div>
  );
}
